import AlphabeticalSort from './AlphabeticalSort';

export default AlphabeticalSort;
